import PropTypes from 'prop-types'

import {useSuiContext} from '@s-ui/react-context'
import {useAnalyticsTrack} from '@adv-mt/mt-tracking-use-analytics'
import {DECODING, FETCH_PRIORITY, LOADING, MediaImage, OBJECT_FIT} from '@adv-mt/ui/media-image'

import {BASE_CLASS as PAGE_BASE_CLASS} from '../../../config.js'
import AdvantageCard from '../advantageCard/index.js'

const BASE_CLASS = `${PAGE_BASE_CLASS}-advantages-carfax`

// Advantages only ever mounts this component when vehicleHistory.hasReport is false — the report state lives in the Trust panel
// This is when the dealer has NOT paid for the carfax report and you can open the report in a new tab
const Carfax = ({adId, vehicleHistory}) => {
  const {domain, i18n} = useSuiContext()
  const {track: analyticsTrack} = useAnalyticsTrack()

  const config = domain.get('config')
  const {TRACKING_EVENT_NAMES} = config.get('tracking')
  const providerLogoSrc = `${config.get('URL_STATICS_IMAGES')}common/logos/carfax-logo-white-box.svg`

  const handleClick = () => {
    domain
      .get('get_advertisements_tracking_use_case')
      .execute({ads: [adId], context: 'other'})
      .then(({products}) => analyticsTrack({data: {products}, event: TRACKING_EVENT_NAMES.VEHICLE_HISTORY_CLICKED}))
  }

  return (
    <AdvantageCard
      href={vehicleHistory.reportUrl}
      onClick={handleClick}
      title={i18n.t('CARFAX.TITLE')}
      description={i18n.t('CARFAX.ADVANTAGE.DESCRIPTION')}
    >
      <MediaImage
        src={providerLogoSrc}
        alt="CARFAX"
        // Inert at current sizing (the box always equals the artwork); kept as a safety net so a
        // future change that stretches the root letterboxes instead of distorting.
        objectFit={OBJECT_FIT.CONTAIN}
        loading={LOADING.LAZY}
        decoding={DECODING.ASYNC}
        fetchPriority={FETCH_PRIORITY.LOW}
        className={`${BASE_CLASS}-logo`}
      />
    </AdvantageCard>
  )
}

Carfax.displayName = 'Carfax'

Carfax.propTypes = {
  adId: PropTypes.string.isRequired,
  vehicleHistory: PropTypes.shape({
    reportUrl: PropTypes.string
  }).isRequired
}

export default Carfax
